import { render, staticRenderFns } from "./ColorCards.vue?vue&type=template&id=70400155&"
import script from "./ColorCards.vue?vue&type=script&lang=js&"
export * from "./ColorCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports